import LayoutLogin from '~componentes/LayoutLogin.vue';
import RecuperarSenhaFornecedor from './RecuperarSenhaFornecedor.vue';

export default {
  path: '/recuperar-senha-fornecedor',
  component: LayoutLogin,
  children: [
    {
      path: '',
      component: RecuperarSenhaFornecedor,
      name: 'recuperarsenhafornecedor',
    },
  ]
}





// WEBPACK FOOTER //
// ./FrontEnd/modulos/recuperar-senha-fornecedor/rotas.js